var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingQcIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5C0.5 1.84315 1.84315 0.5 3.5 0.5H15.5C17.1569 0.5 18.5 1.84315 18.5 3.5V15.5C18.5 17.1569 17.1569 18.5 15.5 18.5H3.5C1.84315 18.5 0.5 17.1569 0.5 15.5V3.5Z",
    stroke: "#D4273F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03235 14.4631C11.9778 14.4631 14.3655 12.0754 14.3655 9.13001C14.3655 6.1846 11.9778 3.79688 9.03235 3.79688C6.08694 3.79688 3.69922 6.1846 3.69922 9.13001C3.69922 12.0754 6.08694 14.4631 9.03235 14.4631Z",
    stroke: "#D4273F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6986 15.8041L12.832 12.9375",
    stroke: "#D4273F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 6.5V9.5",
    stroke: "#D4273F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 11.5H9.03875",
    stroke: "#D4273F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingQcIcon);
export default __webpack_public_path__ + "static/media/PendingQcIcon.fcd5496d21cc82d450ad1b5e1786b4cd.svg";
export { ForwardRef as ReactComponent };